export default class LoadingIndicatorService {
  isVisible = false;

  // Call LoadingIndicator.waitFor() to add promises to track
  // This waits for all promises to resolve, then it shows the loader
  // You can show the loader again later simply by adding another promise to the queue
  constructor(private promiseTracker) {
    'ngInject';

    promiseTracker.onSuccess(() => {
      this.hide();
    });

    promiseTracker.onFail(() => {
      this.show();
    });
  }

  show() {
    this.isVisible = true;
  }

  hide() {
    this.isVisible = false;
  }

  waitFor(promise) {
    this.promiseTracker.waitFor(promise);
    return promise; // allow chaining
  }
}
